import React from "react";
import { Menu, Space } from "antd";
import type { SourceFilter, SourceHierarchy } from "../../../../../../core/data/redux/leads-queue/types";

interface WhatsAppMenuProps {
    sourceHierarchy: SourceHierarchy | null;
    activeFilter: SourceFilter;
    onChange: (filter: SourceFilter) => void;
}

const WhatsAppMenu: React.FC<WhatsAppMenuProps> = ({ sourceHierarchy, activeFilter, onChange }) => {
    if (!sourceHierarchy?.whatsapp) return null;
    const { whatsapp } = sourceHierarchy;

    const handleFilterChange = (level1: string | null) => {
        onChange({ level_1: level1, level_2: null, level_3: null });
    };

    const isActive = (phoneNumberId: string | null) => {
        if (phoneNumberId === null) return !activeFilter.level_1;
        return String(activeFilter.level_1) === String(phoneNumberId);
    };

    const getActiveBusinessName = () => {
        if (!activeFilter.level_1) return null;
        const activeNumber = whatsapp.find((num: any) => String(num.phone_number_id) === String(activeFilter.level_1));
        return activeNumber ? `${activeNumber.business_name} (${activeNumber.display_number})` : null;
    };

    const activeBusinessName = getActiveBusinessName();

    return (
        <Menu selectedKeys={[activeFilter.level_1 ? String(activeFilter.level_1) : "all"]}>
            {activeBusinessName && (
                <>
                    <Menu.Item
                        key="active-filter"
                        disabled
                        style={{
                            backgroundColor: "#e6f7ff",
                            fontWeight: 600,
                            cursor: "default",
                            color: "#1890ff",
                        }}
                    >
                        <Space>
                            <i className="ti ti-filter" style={{ color: "#1890ff" }} />
                            <span>Active: {activeBusinessName}</span>
                        </Space>
                    </Menu.Item>
                    <Menu.Divider />
                </>
            )}

            <Menu.Item
                key="all"
                onClick={() => handleFilterChange(null)}
                style={isActive(null) ? { backgroundColor: "#f0f0f0", fontWeight: 500 } : {}}
            >
                <Space>
                    <i className="ti ti-list" />
                    <span>All WhatsApp Leads</span>
                </Space>
            </Menu.Item>

            <Menu.Divider />

            {whatsapp.map((number: any) => (
                <Menu.Item
                    key={String(number.phone_number_id)}
                    onClick={() => handleFilterChange(String(number.phone_number_id))}
                    style={isActive(String(number.phone_number_id)) ? { backgroundColor: "#e6f7ff", fontWeight: 500 } : {}}
                >
                    <Space>
                        <i className="ti ti-brand-whatsapp" />
                        <span>
                            {number.business_name} ({number.display_number})
                        </span>
                    </Space>
                </Menu.Item>
            ))}
        </Menu>
    );
};

export default WhatsAppMenu;
